import React, { useEffect } from "react";
import LayoutHOC from "../LayoutHOC";
import { useSidebar } from "../SidebarContext";
import AuditLog from "./AuditLog";

const ActivityLogWrapper = ({ customerId }) => {
  // setting name in Header
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  useEffect(() => {
    setheaderProps({ name: "Audit Log" });
    return () => {
      setheaderProps(null);
    };
  }, [setheaderProps]);

  return <AuditLog customerId={customerId} />;
};

export default LayoutHOC(ActivityLogWrapper);
